var map = {
	"./ashtami_dinner.jpg": 2612,
	"./ashtami_lunch.jpg": 2980,
	"./dashami_dinner.jpg": 8923,
	"./dashami_lunch.jpg": 5367,
	"./nabami_dinner.jpg": 109,
	"./nabami_lunch.jpg": 9315,
	"./saptami_dinner.jpg": 1722,
	"./saptami_lunch.jpg": 6592,
	"./shashthi_dinner.jpg": 9616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3188;